import React from "react";
import "./ArticlePreviewContributorsItem.css";
import ReactHtmlParser from "react-html-parser";
import {
  setPreviewingTextLineIDs,
  setPreviewingItemHidingMode
} from "../../redux/actions/editArticlePanel";
import { connect } from "react-redux";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Image from "react-bootstrap/Image";
import downArrow from "../../assets/icon_show_more_arrow.png";

class ArticlePreviewContributorsItem extends React.Component {
  constructor(props) {
    super(props);
    this.onHover = this.onHover.bind(this);
    this.onInvisibleClicked = this.onInvisibleClicked.bind(this);
    this.onHighlightClicked = this.onHighlightClicked.bind(this);
    this.expandClicked = this.expandClicked.bind(this);
    this.state = { expanded: false };
  }

  expandClicked() {
    this.setState({ expanded: true });
  }

  onHover(hovering) {
    const { article, metaDict, setPreviewingTextLineIDs } = this.props;

    const articleID = article.id;

    const contributorID = articleID + "-CONTRIBUTOR";
    const contributorItem = metaDict[contributorID];

    if (hovering) {
      setPreviewingTextLineIDs({ textLineIDs: contributorItem.textLineIDs });
    } else {
      setPreviewingTextLineIDs({ textLineIDs: null });
    }
  }

  onInvisibleClicked() {
    const { mode, article, setPreviewingItemHidingMode } = this.props;
    const articleID = article.id;

    const contributorID = articleID + "-CONTRIBUTOR";

    if (mode === "invisible") {
      setPreviewingItemHidingMode({ id: contributorID, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: contributorID, mode: "invisible" });
    }
  }

  onHighlightClicked() {
    const { mode, article, setPreviewingItemHidingMode } = this.props;
    const articleID = article.id;

    const contributorID = articleID + "-CONTRIBUTOR";

    if (mode === "highlight") {
      setPreviewingItemHidingMode({ id: contributorID, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: contributorID, mode: "highlight" });
    }
  }

  render() {
    const { expanded } = this.state;
    const { article, metaDict, mode } = this.props;
    const articleID = article.id;

    const contributorID = articleID + "-CONTRIBUTOR";
    const item = metaDict[contributorID];

    if (item == null || item.text == null || item.text === "") {
      return null;
    }

    return (
      <div className="article_preview_contributors_container">
        <div
          onMouseEnter={() => this.onHover(true)}
          onMouseLeave={() => this.onHover(false)}
        >
          <p className="article_preview_contributors">
            <span
              style={
                expanded
                  ? {}
                  : { maxHeight: "48pt", display: "block", overflow: "hidden" }
              }
            >
              {ReactHtmlParser(item.text.replace(/\n/g, "<br>"))}
            </span>
            {!expanded && (
              <button
                className="article_preview_contributors_expand"
                onClick={this.expandClicked}
              >
                <Image className="down_arrow" src={downArrow} />
                <span style={{ lineHeight: "24pt" }}>顯示更多</span>
              </button>
            )}
          </p>
        </div>
        <ButtonGroup
          style={{ position: "absolute", top: "40pt", right: "-70px" }}
          size="sm"
        >
          <Button
            variant={mode === "invisible" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onInvisibleClicked}
          >
            <span className="fa fa-eye-slash" />
          </Button>
          <Button
            variant={mode === "highlight" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onHighlightClicked}
          >
            <span className="fa fa-language" />
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

const mapDispatch = {
  setPreviewingTextLineIDs,
  setPreviewingItemHidingMode
};

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const { previewHidingItemIDs } = editArticlePanel;

  const articleID = ownProps.article.id;
  const titleID = articleID + "-CONTRIBUTOR";

  return {
    mode: previewHidingItemIDs[titleID]
  };
};

export default connect(
  mapState,
  mapDispatch
)(ArticlePreviewContributorsItem);
